<template>
    <div class="view login-view no-header">
        <span class="cancel-icon" @click="onCancelClick">×</span>
        <div class="logo-wrap">
            <img class="logo-img" src="../../assets/images/logo.png" alt="logo" />
            <div class="title">微信绑定手机账号</div>
        </div>
        <div class="form-wrap" v-show="type === 1">
            <div class="field-item">
                <input class="field-ipt" placeholder="手机号码" v-model="mobile" />
                <div class="text--error"></div>

            </div>
            <div class="field-item">
                <input class="field-ipt" placeholder="短信验证" v-model="identifying_code" />

                <div class="text--error"></div>
                <van-button
                        class="captcha-btn"
                        plain
                        type="primary"
                        size="mini"
                        @click="getCaptcha"
                        :disabled="countingDown !== 0"
                >{{
                    `${countingDown !== 0 ? `重新发送${countingDown}秒` : '获取验证码'}`
                    }}</van-button
                >
            </div>
        </div>
        <van-button type="primary" class="submit-btn" @click="onSubmitClick"
        >绑定手机号码</van-button
        >
    </div>
</template>
<script>
    import { Button, Checkbox, Switch } from 'vant';
    import { Toast } from 'mint-ui';
    import { setUser } from '../../utils/storageUtil';
    import apiUtil from '../../utils/apiUtil';
    import apiConst from '../../consts/apiConst';

    let timer = null;
    export default {
        name: 'Wechat',
        components: {
            'van-button': Button,
            'van-checkbox': Checkbox,
            'van-switch': Switch
        },

        data() {
            return {
                type: 1, //1-手机号码 2-账号密码 3-微信
                mobile: '',
                identifying_code: '',
                invite_code: '',
                countingDown: 0,
                account: '',
                password: '',
                rememberPass: false
            };
        },
        mounted(){
            window.logincb = (result)=>{
                this.logincb(result)
            }
        },
        methods: {
            async getCaptcha() {
                if (!this.mobile) {
                    Toast('请输入手机号')
                    return;
                }
                const res = await apiUtil.post(apiConst.getCaptcha, {
                    type: 1,
                    mobile: this.mobile
                });
                if (res.success) {
                    Toast({
                        message: '发送成功',
                        duration: 1000,
                        background: '#8FC31E'
                    });
                    this.countingDown = 60;
                    timer = setInterval(() => {
                        this.countingDown--;
                        if (this.countingDown === 0) {
                            clearInterval(timer);
                        }
                    }, 1000);
                }
            },

            async onSubmitClick() {
                let params = {}
                if (this.type === 1) {
                    if (!this.mobile || !this.identifying_code) {
                        Toast('登录信息填写不完整')
                        return
                    }
                    params = {
                        user_auth_id: this.$route.query.user_auth_id,
                        mobile: this.mobile,
                    }
                }
                const res = await apiUtil.post(apiConst.wxThirdBind, params);
                if (res.success) {
                    const {token, type, uid} = res;
                    setUser({token, type, uid});
                    this.$router.push('discover');
                }
            },

            onCancelClick() {
                window.history.go(-1)
            },

            onForgetClick() {
                this.$router.push('/forget')
            },
            otherLogin() {
                window.HostApp.login(2, 'logincb')
            },
            logincb(result) {
                let paramsObj = JSON.parse(result);
                let params = {
                    type: 5,
                    openid: paramsObj.openid,
                    access_token: paramsObj.access_token
                }
                // alert("can:"+JSON.stringify(params))
                const wxResult = apiUtil.post(apiConst.submitLoginReg, params);
                // alert(JSON.stringify(wxResult))
                if (wxResult.success) {
                    const {token, type, uid} = res;
                    setUser({token, type, uid});
                    this.$router.push('discover');
                }
            }
        }
    };
</script>
<style lang="stylus" scoped>
    .login-view {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .cancel-icon {
            position: absolute;
            left: 30px;
            top: 30px;
            font-size: 72px;
            font-weight: bold;
        }

        .logo-wrap {
            text-align: center;
            margin-bottom: 30px;
            .logo-img {
                width: 154px;
                height: 154px;
                margin-bottom: 42px;
            }

            .title {
                color: #333;
                font-size: 38px;
                font-weight: bold;
            }
        }

        .form-wrap {
            .field-item {
                position: relative;
                width: 497px;
                height: 107px;
                padding: 10px 0 0 0px;
                border-bottom: 1PX solid #979797;

                .field-ipt {
                    padding-top: 30px;
                    height: 100%;
                    font-size: 32px;
                    &::-webkit-input-placeholder {
                        color: #999;
                        font-size: 32px;
                    }
                }

                .captcha-btn {
                    position: absolute;
                    padding: 0 13px;
                    height: 48px;
                    line-height: 46px;
                    right: 8px;
                    bottom: 12px;
                    font-size: 28px;
                }
            }
            .field-item--cbx{
                display: flex;
                align-items center;
                justify-content space-between
                margin-top: 80px;
                color: #666;
                font-size: 28px;

                .remember-cbx {
                    color: #666 !important
                    .van-icon {
                        width: 22px;
                        height: 22px;
                    }
                }
            }

            .field-item--switch {
                margin-top: 30px;
                display: flex;
                align-items: center;
                .invite-switch {
                    width: 60px;
                    height: 40px;
                    margin-right: 10px;
                    .van-switch__node{
                        top: 2px;
                        left: 2px;
                        width: 36px;
                        height: 36px;
                    }
                    &.van-switch--on{
                        .van-switch__node{
                            transform: translateX(22px)

                        }
                    }
                }
            }



            .invite-text {
                color: #666;
                font-size: 28px;
            }
        }

        .submit-btn {
            margin-top: 64px;
            width: 497px;
            height: 76px;
            line-height: 76px;
            background-color: #8FC31E;
            border-radius: 4px;
            color: #fff;
            text-align: center;
        }

        .a-btn {
            margin-top: 28px;
            font-size: 28px;
            text-decoration: underline
        }

        .tip {
            font-size: 26px
            margin-top: 60px;
            .agreement-text {
                color: #8FC31E
            }
        }

        .other-wrap{
            position relative
            text-align: center
            border-top: 1PX solid #979797
            margin-top: 50px;
            padding-top 40px
            width 497px
            .tip--small {
                display: inline-block;
                width: 140px;
                position: absolute;
                top: -13px;
                left: 50%;
                margin-left: -70px;
                background-color: #fff;
                font-size: 20px;
                color: #666;
            }

            .wechat-img {
                width 56px
                height 56px
            }
        }


    }
</style>
